import { canOperateMaintenance } from '../utils/maintenance-operators.util';

export const menuItems: MenuItem[] = [
  // {
  //   access: 'DASHBOARD_BI_SUPER_ADMIN',
  //   routerLink: './dashboard',
  //   icon: 'fa-chart-line',
  //   svg: `<svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //           <path class="fill-current text-slate-600" d="M4 19.5A1.5 1.5 0 015.5 18h14a1 1 0 110 2h-14A1.5 1.5 0 014 18.5v1z"/>
  //           <path class="fill-current text-slate-400" d="M5 15.5a1 1 0 01-.7-1.7l4-4a1 1 0 011.4 0l2.3 2.3 4.3-5.3a1 1 0 011.55 1.26l-5 6.15a1 1 0 01-1.48.08L9 11.92l-3.3 3.3a1 1 0 01-.7.28z"/>
  //         </svg>`,
  //   label: 'Dashboard BI',
  //   subItems: [
  //     {
  //       access: 'DASHBOARD_BI_SUPER_ADMIN',
  //       routerLink: './dashboard',
  //       label: 'Resumen ejecutivo'
  //     }
  //   ]
  // },
  {
    access: 'FREE_ACCESS',
    routerLink: './account/profile',
    icon: 'fa-user',
    svg: `<svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
            <path class="fill-current text-slate-400" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"></path>
          </svg>`,
    label: 'Perfil',
    subItems: [
      {
        access: 'FREE_ACCESS',
        routerLink: './account/profile',
        label: 'Mi cuenta'
      }
    ]
  },
  {
    // OR: basta con uno para ver el acordeón; cada subítem sigue filtrando con su propio access.
    access: [
      'VER_MENU_APROBADAS_EXP',
      'VER_MENU_POR_APROBAR_EXP',
      'VER_MENU_EN_CREACION_EXP',
      'VER_MENU_SUSPENDIDAS_EXP',
      'VER_MENU_PASADAS_EXP',
      'VER_MENU_TODAS_EXP',
      'VER_MENU_VENTAS_EXP',
      'VER_LIQUIDACIONES'
    ],
    routerLink: './experiences',
    icon: 'fa-circle-parking',
    svg: `<svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
            <path class="fill-current text-slate-600" d="M20 7a.75.75 0 01-.75-.75 1.5 1.5 0 00-1.5-1.5.75.75 0 110-1.5 1.5 1.5 0 001.5-1.5.75.75 0 111.5 0 1.5 1.5 0 001.5 1.5.75.75 0 110 1.5 1.5 1.5 0 00-1.5 1.5A.75.75 0 0120 7zM4 23a.75.75 0 01-.75-.75 1.5 1.5 0 00-1.5-1.5.75.75 0 110-1.5 1.5 1.5 0 001.5-1.5.75.75 0 111.5 0 1.5 1.5 0 001.5 1.5.75.75 0 110 1.5 1.5 1.5 0 00-1.5 1.5A.75.75 0 014 23z">
            </path>
            <path class="fill-current text-slate-400" d="M17 23a1 1 0 01-1-1 4 4 0 00-4-4 1 1 0 010-2 4 4 0 004-4 1 1 0 012 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-1 1zM7 13a1 1 0 01-1-1 4 4 0 00-4-4 1 1 0 110-2 4 4 0 004-4 1 1 0 112 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-1 1z">
            </path>
          </svg>`,
    label: 'Experiencias',
    subItems: [
      {
        access: 'VER_MENU_APROBADAS_EXP',
        routerLink: './experiences/list/approved',
        label: 'Aprobadas'
      },
      {
        access: 'VER_MENU_POR_APROBAR_EXP',
        routerLink: './experiences/list/pending',
        label: 'Por Aprobar',
        notification: 0
      },
      {
        access: 'VER_MENU_EN_CREACION_EXP',
        routerLink: './experiences/list/create',
        label: 'En creación'
      },
      {
        access: 'VER_MENU_SUSPENDIDAS_EXP',
        routerLink: './experiences/list/suspended',
        label: 'Suspendidas'
      },
      {
        access: 'VER_MENU_PASADAS_EXP',
        routerLink: './experiences/list/finished',
        label: 'Pasadas'
      }, {
        access: 'VER_MENU_TODAS_EXP',
        routerLink: './experiences/list/all',
        label: 'Todas'
      },
      {
        access: 'VER_MENU_VENTAS_EXP',
        routerLink: './experiences/sales',
        label: 'Ventas'
      },
      // Funciones con la venta cerrada y sin liquidar, por experiencia. Como en v1, la
      // liquidación vive solo en Experiencias (Por liquidar / Liquidadas).
      {
        access: 'VER_LIQUIDACIONES',
        routerLink: './experiences/list/to-settle',
        label: 'Por liquidar'
      },
      // Funciones ya liquidadas, por experiencia; desde aquí se desliquidan.
      {
        access: 'VER_LIQUIDACIONES',
        routerLink: './experiences/list/settled',
        label: 'Liquidadas'
      }
    ]
  },
  {
    // Gate de menú: solo visible con MENU_VENUES_MN (los subítems filtran aparte).
    access: 'MENU_VENUES_MN',
    routerLink: './venues',
    icon: 'fa-venue',
    svg: `<svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
            <path class="fill-current text-slate-400" d="M13 15l11-7L11.504.136a1 1 0 00-1.019.007L0 7l13 8z"></path>
            <path class="fill-current text-slate-700" d="M13 15L0 7v9c0 .355.189.685.496.864L13 24v-9z"></path>
            <path class="fill-current text-slate-600" d="M13 15.047V24l10.573-7.181A.999.999 0 0024 16V8l-11 7.047z"></path>
          </svg>`,
    label: 'Venues',
    subItems: [
      {
        access: 'CREAR_INFORMACION_VEN',
        routerLink: './venues/create',
        label: 'Crear'
      },
      {
        access: 'VER_INFORMACION_VEN',
        routerLink: './venues/list',
        label: 'Listar'
      }
    ]
  },
  {
    // Gate de menú: solo visible con MENU_USUARIOS_MN (los subítems filtran aparte).
    access: 'MENU_USUARIOS_MN',
    routerLink: './users',
    icon: 'fa-users',
    svg: `<svg class="shrink-0 h-6 w-6 pointer-events-none" viewBox="0 0 24 24">
            <path class="fill-current text-slate-600" d="M18.974 8H22a2 2 0 012 2v6h-2v5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5h-2v-6a2 2 0 012-2h.974zM20 7a2 2 0 11-.001-3.999A2 2 0 0120 7zM2.974 8H6a2 2 0 012 2v6H6v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5H0v-6a2 2 0 012-2h.974zM4 7a2 2 0 11-.001-3.999A2 2 0 014 7z" />
            <path class="fill-current text-slate-400" d="M12 6a3 3 0 110-6 3 3 0 010 6zm2 18h-4a1 1 0 01-1-1v-6H6v-6a3 3 0 013-3h6a3 3 0 013 3v6h-3v6a1 1 0 01-1 1z" />
          </svg>`,
    label: 'Usuarios',
    subItems: [
      {
        access: 'CREAR_USUARIO_US',
        routerLink: './users/create',
        label: 'Crear'
      },
      {
        access: 'VER_USUARIO_US',
        routerLink: './users/list',
        label: 'Listar'
      }
    ]
  },
  {
    // Gate de menú: solo visible con MENU_SOPORTE_MN (los subítems filtran aparte).
    access: 'MENU_SOPORTE_MN',
    routerLink: './admin/support/logs',
    icon: 'fa-life-ring',
    svg: `<svg class="shrink-0 h-6 w-6 pointer-events-none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path class="fill-current text-slate-600" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            <circle class="fill-current text-slate-400" cx="12" cy="12" r="3"/>
          </svg>`,
    label: 'Soporte',
    subItems: [
      { access: 'SOPORTE_VER_LOGS_USUARIO', routerLink: './admin/support/logs', label: 'Logs por usuario' },
      // Agregados de dispositivos, sistemas y navegadores (permiso propio, sin datos por persona).
      { access: 'SOPORTE_VER_PANEL_DISPOSITIVOS', routerLink: './admin/support/devices', label: 'Dispositivos y navegadores' },
      // C2-ARQ-002 — Componente dedicado en su propia ruta (no más mezclado en tabs de support-logs).
      { access: 'VER_COLA_EMAILS', routerLink: './admin/support/email-queue', label: 'Cola de Emails' },
      // Reembolsos de pagos Mercado Pago (Orders): total o parcial, con motivo.
      { access: 'CREAR_REEMBOLSO_PAGO_CONF', routerLink: './admin/mercadopago-refunds', label: 'Reembolsos Mercado Pago' },
    ]
  },
  {
    // Gate de menú: solo visible con MENU_GESTION_DINERO_MN (los subítems filtran aparte).
    access: 'MENU_GESTION_DINERO_MN',
    routerLink: './admin/withdrawals',
    icon: 'fa-wallet',
    svg: `<svg class="shrink-0 h-6 w-6 pointer-events-none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path class="fill-current text-slate-600" d="M3 5h18v3H3V5zm0 4h18v11H3V9z"/>
            <path class="fill-current text-slate-400" d="M15 12h4v3h-4v-3z"/>
          </svg>`,
    label: 'Gestión de dinero',
    subItems: [
      { access: 'VER_PAGOS_ASINCRONOS_CONF', routerLink: './admin/async-payments/list', label: 'Pagos asíncronos' },
      { access: 'GESTIONAR_RETIROS_WALLET', routerLink: './admin/withdrawals/list', label: 'Gestionar retiros' },
      { access: 'VER_AUDITORIA_ABONOS_WALLET', routerLink: './admin/wallet-credits/list', label: 'Auditoría de abonos' },
      {
        access: 'CONFIGURAR_LIMITES_WALLET',
        routerLink: './admin/wallet-credit-limits',
        label: 'Configurar límites de wallet'
      },
      // A-ARQ-005 — Reporte de cuadres de cajeros (sesiones de caja).
      {
        access: 'VER_REPORTES_CAJA',
        routerLink: './admin/cashier-sessions',
        label: 'Sesiones de caja'
      }
    ]
  },
  {
    // Gate de menú: solo visible con MENU_CONFIGURACION_MN (los subítems filtran aparte).
    access: 'MENU_CONFIGURACION_MN',
    routerLink: './settings',
    icon: 'fa-settings',
    svg: `<svg class="shrink-0 h-6 w-6 pointer-events-none" viewBox="0 0 24 24">
            <path class="fill-current text-slate-600" d="M19.714 14.7l-7.007 7.007-1.414-1.414 7.007-7.007c-.195-.4-.298-.84-.3-1.286a3 3 0 113 3 2.969 2.969 0 01-1.286-.3z">
            </path>
            <path class="fill-current text-slate-400" d="M10.714 18.3c.4-.195.84-.298 1.286-.3a3 3 0 11-3 3c.002-.446.105-.885.3-1.286l-6.007-6.007 1.414-1.414 6.007 6.007z">
            </path>
            <path class="fill-current text-slate-600" d="M5.7 10.714c.195.4.298.84.3 1.286a3 3 0 11-3-3c.446.002.885.105 1.286.3l7.007-7.007 1.414 1.414L5.7 10.714z">
            </path>
            <path class="fill-current text-slate-400" d="M19.707 9.292a3.012 3.012 0 00-1.415 1.415L13.286 5.7c-.4.195-.84.298-1.286.3a3 3 0 113-3 2.969 2.969 0 01-.3 1.286l5.007 5.006z">
            </path>
          </svg>`,
    label: 'Configuración',
    subItems: [
      {
        access: 'VER_PERFIL_PERMISO_PRE',
        routerLink: './settings/profiles',
        label: 'Perfiles y Permisos'
      },
      {
        access: 'FREE_ACCESS',
        routerLink: './settings/maintenance',
        label: 'Mantenimiento',
        operatorsOnly: true,
      },
      {
        access: 'VER_ATRIBUTOS_CONF',
        routerLink: './settings/attributes',
        label: 'Atributos'
      },
      {
        access: 'VER_TERMINOS_CONF',
        routerLink: './settings/terms-and-conditions',
        label: 'Términos y Condiciones'
      },
      {
        access: 'VER_CATEGORIA_EVENTO_CONF',
        routerLink: './settings/event-categories',
        label: 'Categorías de Evento'
      },
      {
        access: 'VER_CAMPOS_ADICIONALES_CONF',
        routerLink: './settings/additional-fields',
        label: 'Campos adicionales'
      },
      {
        access: 'VER_IMPUESTOS_CONF',
        routerLink: './settings/taxes',
        label: 'Impuestos'
      },
      {
        access: 'VER_CANALES_ABONO_WALLET',
        routerLink: './settings/wallet-funding-channels',
        label: 'Canales de abono'
      },
      {
        access: 'VER_CUENTAS_BANCARIAS_GLOBAL',
        routerLink: './admin/banks-accounts',
        label: 'Cuentas Asíncronas'
      },
      {
        access: 'VER_BANNERS_CARTELERA',
        routerLink: './admin/billboard-banners',
        label: 'Banners de cartelera'
      },
      {
        access: 'SUPER_ADMIN',
        routerLink: './settings/white-label',
        label: '🎨 Marca Blanca'
      }
    ]
  }

];

export interface SubItem {
  access: string | string[] | null;
  routerLink: string | null;
  label: string;
  notification?: number;
  action?: string;
  /** C2-ARQ-002 — Opcional, pasa al routerLink. Permite reusar el mismo
   *  component con tabs distintos (e.g. support/logs con tab=email-queue). */
  queryParams?: Record<string, string>;
  /**
   * Solo para los correos de `MAINTENANCE_OPERATORS` (no es un permiso ni alcanza con ser
   * super admin). Lo aplica `menuItemsForUser`; `access` queda en FREE_ACCESS para que la
   * directiva no lo esconda a un operador que no sea super admin.
   */
  operatorsOnly?: boolean;
}

/**
 * El menú para esta persona: una copia nueva (el layout le escribe las notificaciones) sin
 * los subítems reservados a operadores cuando el correo no está en la lista.
 */
export function menuItemsForUser(email: unknown): MenuItem[] {
  const puedeOperar = canOperateMaintenance(email);
  return structuredClone(menuItems).map((item) => ({
    ...item,
    subItems: item.subItems.filter((sub) => !sub.operatorsOnly || puedeOperar),
  }));
}

export interface MenuItem {
  access: string | string[] | null;
  routerLink: string;
  icon: string;
  svg?: string;
  label: string;
  subItems: SubItem[];
}
